// Set up for prerender
import React from 'react';
import ReactDOM from 'react-dom';
import ReactDOMServer from 'react-dom/server';

// Make React available globally for react-rails
window.React = React;
window.ReactDOM = ReactDOM;
window.ReactDOMServer = ReactDOMServer;

import ReactRailsUJS from 'react_ujs';

// Polyfill for classes see https://babeljs.io/docs/usage/polyfill/
// import '@babel/polyfill';

// import BetterNav from '../components/better-nav';

import Timetable from '../components/weekly_prog/index.jsx';

// // Set up for global scope - PLEASE DO NOT TOUCH
const app = (window.app = global.app = {});

// // <<<<<<<<<<<<< Please add all components to APP >>>>>>>>>>>>

// //  Components
// // app.BetterNav = BetterNav;
app.Timetable = Timetable;

// Initialise ReactUJS
ReactRailsUJS.mountComponents();
